import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from '../../comum/Context/auth';
import './index.css';
import { api } from '../../services/api';
import logoSmall from './../../comum/assets/arbor.png';
import {Link,  useNavigate,useParams }  from 'react-router-dom'; 
import SweetAlert from 'react-bootstrap-sweetalert';

import Menu from "../../comum/Menu/menu.jsx";
import Footer from '../../comum/Footer/index.jsx';

function Validacaousr() {
  const navigate         = useNavigate();
  const {tipo}           = useParams();
  const {validacao}      = useParams();  
  const [email, setEmail    ]           = useState('');
  const [sucesso, setSucesso]           = useState(false);
  const [erro, setErro]                 = useState(false);
  const [retorno, setRetorno]           = useState('');
  const inputRef = useRef(null);
  const [eyesIsClosed, setEyeState]     = useState(false);  




  function ValidaUsuario(){
    api.get('/usuario/validacao/'+tipo+'/'+email+'/'+validacao
    )
    .then(async response => {
        await
        setErro(response.data.erro);
        setRetorno(response.data.retorno);
        localStorage.setItem("logado", "S");
        if (response.data.erro=== 'S') {
          setSucesso(false);
          setErro(true);
        }
        else {
          setSucesso(true);
          setErro(false);
        };
        
        console.log(retorno.data);        
    })
    .catch((err) => {             
        console.log(err);           
        localStorage.setItem("logado", "N");
        setErro(true);  
    });
  };

  function alterarEmail(event){      
    setEmail(event.target.value);
    setSucesso('');  
  }

  function IrParaHome(event){    
    return navigate('/');
    setSucesso(false);
  }
  return ( <div>
    <Menu /> 
    <div className="d-flex align-items-center text-center form-container">      
      <form className="form-signin">
        <img className="mb-4 img-logo" src={logoSmall} alt="" />
        <h1 className="h3 mb-3 fw-normal">Validação</h1>
        
        <div className="form-floating">
          <input onChange={alterarEmail} type="number" className="form-control" id="floatingInput" placeholder="E-mail" />
          <label htmlFor="floatingInput">Matrícula</label>
        </div>
        
        <button onClick={ValidaUsuario} className="w-100 btn btn-lg btn-success" type="button">Confirmar</button>
        <div className="login-links mt-5">
          {/*<Link to="/restaurante/resetsenha" className="mx-3 font-link">Esqueci minha senha</Link>
          <Link to="/restaurante/novaconta" className="mx-3 font-link">Criar uma conta</Link>*/}
        </div>

        <p className="mt-5 mb-3 text-muted">&copy; Desenvolvido por F2 Enterprise</p>

      </form>
      {sucesso ?
                    <SweetAlert
                        success
                        showCloseButton
                        confirmBtnText="Continuar"
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        title="Sucesso"
                        onConfirm={() => IrParaHome()}
                        reverseButtons={false}
                        openAnim={{ name: 'showSweetAlert', duration: 2000 }}
                        closeAnim={{ name: 'hideSweetAlert', duration: 100 }}
                    >   {retorno}
                    </SweetAlert> : null
                }

                {erro ?
                        <SweetAlert
                            danger
                            showCloseButton
                            confirmBtnText="OK"
                            confirmBtnBsStyle="danger"
                            onConfirm={() => setErro('')}
                            title="Falha"
                            reverseButtons={false}
                            openAnim={{ name: 'showSweetAlert', duration: 2000 }}
                            closeAnim={{ name: 'hideSweetAlert', duration: 100 }}
                        >   {retorno}
                        </SweetAlert> : null
                }

    </div>
    <Footer />
    </div>
  );
}

export default Validacaousr;
